module.exports = __webpack_public_path__ + "static/img/award-8.2d53edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/award-8.jpg
// module id = JMfo
// module chunks = 1